import React, { Component } from 'react';
import axios from 'axios';

require(`../assets/${process.env.PAGE}/css/components/camera.css`);

import RenaperStepErrorMessage from './RenaperStepErrorMessage.js';

import PhotoSelfieCamera from './SelfieWithDocumentSelfieCamera.js';
import CustomSpinner from './CustomSpinner.js';


const SELFIE_TYPES = [
  {
    type:"SCD",
    description: "Sostené tu dni de frente",
    icon: require(`../assets/common/photo-identity/scd.png`),
    successIcon: require(`../assets/common/photo-identity/scd.png`),
  },
];

class SelfieWithDocumentRegister extends Component {
  constructor(props){
    super(props);

    this.state = {
        files: [],
        currentType: null,
        lastType: false,
        selfiesTypes: [],
        play: false,
        loading: false,
        browserFingerPrint: null,
        stepError: false,
        errorMessage: null,
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setBrowserFingerPrint = this.setBrowserFingerPrint.bind(this);
  }


  async componentDidMount(){
    this.setState({
        currentType: SELFIE_TYPES[0],
    });
    var vuFp = new window.VUBrowserFP();
    vuFp.getFingerprintInfoWithSeed(this.setBrowserFingerPrint);
  }

  handleChange(file){
    const { currentType, selfiesTypes, files, browserFingerPrint } = this.state;
    files.push({
      imageType: currentType.type,
      file: file
    });

    this.setState({
      ...this.state,
      files: files,
    });

      this.setState({
        ...this.state,
        lastType: true,
        loading: true,
      });
      const ROOT_URL = process.env.API_URL;

      const config = {
          headers:
              {
                  'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                  'Content-Type': 'multipart/form-data'
              }
      };

      const formData = new FormData();

      formData.append('renaper_browser_fingerprint', browserFingerPrint)

      files.forEach((selfie) => {
        formData.append(selfie.imageType, selfie.file)
      });

      axios.post(`${ROOT_URL}/identity/selfiewithdocument/register`, formData, config)
      .then((response)=> {
        if(response.status >= 200 && response.status <= 300){
          if (!response.data.status) {
            this.setState({
              ...this.state,
              stepError: true
            })
            setTimeout(this.props.onRollback, 5 * 1000);
          }
          else {
            this.props.onFinish();
          }
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          stepError: true
        })
        setTimeout(this.props.onRollback, 5 * 1000);
      });

  }

  handleClick(event){
    event.preventDefault();
    this.setState({
      ...this.state,
      play: true,
      stepError: false,
    });
  }

  setBrowserFingerPrint(browserInfo){

    var result =  browserInfo.fingerprint;
    this.setState({
      ...this.state,
      browserFingerPrint: result
    })
  }


  render() {
    const { currentType, lastType, play, loading, stepError } = this.state;

    const startButton = (
      <div style={{
        textAlign: "center"
      }}>
        <h4>Colocá tu rostro en el círculo y pulsá el botón comenzar</h4>
        <button
          onClick={this.handleClick}
          className='btn btn-primary btn-lg action-button'>
            Comenzar
        </button>
      </div>
    );

    const errorMessage = (<RenaperStepErrorMessage/>);

    return (
      <div style={{
        position: "fixed",
        left: 0,
        top: 0,
        height: "100%",
        width: "100%",
        background: "#000",
      }} >
        {loading && <CustomSpinner message={ stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' } />}
        <PhotoSelfieCamera
          play={play}
          fileType={currentType}
          lastType={lastType}
          onChange={this.handleChange}
          onStart={this.handleClick}
          interval={8}
          shapeStyle={{
              aspectRatio: 1,
              defaultFixedSide: 'height',
              borderRadius: '0%',
              captureOptions: {
                  audio: false,
                  video: true
              }
          }}/>
        { !play && startButton }
      </div>)

  }
}
module.exports = SelfieWithDocumentRegister


/** WEBPACK FOOTER **
 ** ./src/components/SelfieWithDocumentRegister.js
 **/